import { render, staticRenderFns } from "./AppSearchDialog.vue?vue&type=template&id=b11408a0&"
import script from "./AppSearchDialog.vue?vue&type=script&lang=js&"
export * from "./AppSearchDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppSearchDialog.vue?vue&type=style&index=0&id=b11408a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports